module.exports = __webpack_public_path__ + "static/img/s5.99c7506.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/s5.png
// module id = Vi9X
// module chunks = 1